'use client'

import { ClinicaHorarioItem } from '../../lib/services'

interface HorariosClinicaProps {
  horarios: ClinicaHorarioItem[]
  className?: string
}

export default function HorariosClinica({ horarios, className = '' }: HorariosClinicaProps) {
  const diasSemana: { [key: number]: string } = {
    1: 'Segunda-feira',
    2: 'Terça-feira',
    3: 'Quarta-feira',
    4: 'Quinta-feira',
    5: 'Sexta-feira',
    6: 'Sábado',
    7: 'Domingo'
  }

  // Ordenar horários por dia da semana
  const horariosOrdenados = [...horarios].sort((a, b) => a.dia - b.dia)

  if (horarios.length === 0) {
    return (
      <div className={`bg-white rounded-lg shadow-sm p-6 ${className}`}>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Horários de Funcionamento
        </h3>
        <p className="text-gray-600">Horário não informado</p>
      </div>
    )
  }

  return (
    <div className={`bg-white rounded-lg shadow-sm p-6 ${className}`}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Horários de Funcionamento
      </h3>

      <div className="space-y-3">
        {horariosOrdenados.map((horario) => (
          <div key={`${horario.dia}-${horario.de}`} className="flex justify-between items-center border-b border-gray-100 last:border-0 pb-2 last:pb-0">
            <span className="font-medium text-gray-700">
              {diasSemana[horario.dia] || `Dia ${horario.dia}`}
            </span>
            <div className="text-right">
              <span className="text-gray-900">
                {horario.de} às {horario.ate}
              </span>
              {horario.intervalo_ini && horario.intervalo_fim && (
                <div className="text-xs text-gray-500">
                  (Intervalo: {horario.intervalo_ini} - {horario.intervalo_fim})
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-blue-800 text-sm">
          <strong>Observação:</strong> Os horários podem sofrer alterações em feriados.
        </p>
      </div>
    </div>
  )
}
